export default __webpack_public_path__ + "static/media/emptyCart.84fe2dad.svg";